import { render } from "./DescSlider.vue?vue&type=template&id=bf3a64b8"
import script from "./DescSlider.vue?vue&type=script&lang=js"
export * from "./DescSlider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Projects\\maytoni\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__